import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { getCountryList, getServiceOfferingsList } from "../../api";
import { FORM_FIELDS } from "../../constants";
import { FormDropDown, FormTextInput } from "../core";

export const SearchFormInternal = ({ register, control }) => {
  const [serviceofferingOptions, setServiceofferingOptions] = useState([]);
  const [selectedServiceOfferings, setSelectedServiceOfferings] = useState([]);
  const [selectedServiceCountries, setSelectedServiceCountries] = useState([]);

  useEffect(() => {
    const getServiceOfferings = async () => {
      const resp = await getServiceOfferingsList({
        operation: "fetchServiceOffering",
      });

      const serviceOfferings = resp?.map((data) => data.name) || [];
      setServiceofferingOptions(serviceOfferings);
    };
    getServiceOfferings();
  }, []);

  const handleServicesProvidedChange = (selected) => {
    setSelectedServiceOfferings(selected);
  };

  const handleServiceCountriesChange = (selected) => {
    setSelectedServiceCountries(selected);
  };

  return (
    <>
      <Controller
        control={control}
        name="servicesProvided"
        render={({ field: { onChange, value } }) => (
          <FormDropDown
            creatable={true}
            isMulti={true}
            selectAll={true}
            labelName={FORM_FIELDS.SERVICES_PROVIDED}
            requiredAny={true}
            options={serviceofferingOptions || []}
            onChange={(selected) => {
              onChange(selected);
              handleServicesProvidedChange(selected);
            }}
            value={selectedServiceOfferings}
          />
        )}
      />
      <FormTextInput
        labelName={FORM_FIELDS.SERVICE_PROVIDER_NAME}
        id="serviceProviderName"
        requiredAny={true}
        {...register("serviceProviderName", { required: false })}
      />
      <Controller
        control={control}
        name="serviceCountries"
        render={({ field: { onChange, value } }) => (
          <FormDropDown
            isMulti={true}
            selectAll={true}
            labelName={FORM_FIELDS.SERVICE_COUNTRIES}
            requiredAny={true}
            isClearable
            options={getCountryList() || []}
            onChange={(selected) => {
              onChange(selected);
              handleServiceCountriesChange(selected);
            }}
            value={selectedServiceCountries}
          />
        )}
      />
    </>
  );
};

SearchFormInternal.propTypes = {
  control: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
};
